import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import IntegrationsProcess from "./routes/IntegrationsProcess";

import RosterSync from "./routes/RosterSync";
import AttendanceSync from "./routes/AttendanceSync";
import GradeBookSync from "./routes/GradeBookSync";
import TimetableSync from "./routes/TimetableSync";

export default store => ({
  path: ":curriculumId/:service",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "admin-schoolSetup-integrations" */ "./components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;

        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    IntegrationsProcess(store),
    RosterSync(store),
    AttendanceSync(store),
    GradeBookSync(store),
    TimetableSync(store),
  ],
});
